module.exports = __webpack_public_path__ + "img/ic_bookselection@2x.e94cc266.png";